module.exports = __webpack_public_path__ + "static/media/2. Prisma1, Óleo y resina sobre lámina de acrílico, 80 x 20 x 20 cm, 2016 copy.97b66d93.png";